<div class="row">
<div class="col-sm-12 text-center">
<div class="text-center">

  <img *ngIf="icons.length>0" [src]="icons[0]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon d-none d-md-inline"/>
  <img src="assets/images/girl_reading_128.png" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid d-inline d-md-none"/>
  <img src="assets/images/girl_reading256.png" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid  d-none d-md-inline" />
  <img *ngIf="icons.length>0" [src]="icons[1]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon d-none d-md-inline"/>
</div>
  </div>
  </div>

<div class="row mt-3">

<div class="col-md-3 text-center d-none d-md-inline">
  <p>
    <img *ngIf="icons.length>0" [src]="icons[2]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon"/>
    <img *ngIf="icons.length>0" [src]="icons[3]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon"/>
  </p>
  <p class="mt-3">
  <img *ngIf="icons.length>0" [src]="icons[4]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon"/>
  <img *ngIf="icons.length>0" [src]="icons[5]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon"/>
  </p>

</div>

<div class="col-sm-12 col-md-6 login-form-container">



            <div *ngIf="loading">
                <app-loading-spinner></app-loading-spinner>
            </div>
            <div class="alert alert-info text-center" *ngIf="!isLoginPassed">
              <i class="fa fa-exclamation"></i> Login Failed. No user found with  username and password provided
            </div>
            <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!loading">
                <div class="form-group  input-group-lg" [ngClass]="{error:f.username.errors && f.username.touched}">
                    <input placeHolder="Email Address"
                    type="text" formControlName="username"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
                    id="username"/>
                    <div *ngIf="f.username.errors && f.username.touched">
                        <ul>
                            <li>Invalid email</li>
                          </ul>
                    </div>
                </div>

                <div class="form-group  input-group-lg mt-3" [ngClass]="{error:f.password.errors && f.password.touched}">
                    <input placeHolder="Password"
                    type="password"
                    formControlName="password"
                    class="form-control"
                    id="password"/>
                    <div *ngIf="f.password.errors && f.password.touched">
                        <ul>
                            <li>Password requires minimum 5 characters</li>
                          </ul>
                    </div>
                </div>

                <div class="form-group  mt-5">
                    <div class="col-sm-12 text-center">
                    <button [disabled]="loading" class="btn btn-primary  btn-lg btn-block" id="btnLoginId">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                        Login
                    </button>
                </div>
                </div>
                <div class="col-sm-10 offset-sm-2 mt-4">
                    <ul class="non-style">
                        <li> <i class="fa fa-caret-right"></i> Don't have an account? <a [routerLink]="['/user/new/step/one']">Register </a></li>
                        <li> <i class="fa fa-caret-right mt-4"></i> Forgotten Account? <a [routerLink]="['/user/forgotten/password/email/input']">Recover Account </a></li>
                    </ul>
                </div>
            </form>



</div>


<div class="col-md-3 text-center d-none d-md-inline">
  <p>
    <img *ngIf="icons.length>0" [src]="icons[6]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon"/>
    <img *ngIf="icons.length>0" [src]="icons[7]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon"/>
  </p>

  <p class="mt-3">
    <img *ngIf="icons.length>0" [src]="icons[8]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon"/>
    <img *ngIf="icons.length>0" [src]="icons[9]" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid icon"/>
  </p>

   </div>

</div>

<div class="row">
  <div class="col-sm-12 text-center">
    <img src="assets/images/login_page_addon.png" alt="Children stay motivated with daily streaks and rewards on the Boldungu Math app." class="img-fluid"/>
</div>
</div>
<app-country-level-syllabus></app-country-level-syllabus>

